
import Vue from "vue";
import { getAdminLogging, searchAdminLogging } from "@/api";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle";

export default Vue.extend({
  name: "ReviewHistory",
  components: {
    TempStarsTableTitle
  },
  data: () => {
    return {
      loading: true,
      dialog: false,
      search: "",
      hygienistId: "",
      firstName: "",
      lastName: "",
      practiceName: "",
      locationId: "",
      email: "",
      errorMessage: "",
      list: [],
      headers: [
        { text: "ID", value: "id" },
        { text: "Admin ID", value: "adminId" },
        { text: "Time stamp", value: "timeStamp" },
        { text: "Button used", value: "buttonUsed" },
        { text: "Hygienist ID", value: "hygienistId" },
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "Location ID", value: "locationId" },
        { text: "Practice Name", value: "practiceName" },
        { text: "Email", value: "email" }
      ]
    };
  },
  async created() {
    this.list = await getAdminLogging();
    this.loading = false;
  },
  methods: {
    async submitForm(): Promise<void> {
      const fields = [
        this.hygienistId && {
          column: "hygienistId",
          value: this.hygienistId
        },
        this.firstName && {
          column: "firstName",
          value: this.firstName
        },
        this.lastName && {
          column: "lastName",
          value: this.lastName
        },
        this.practiceName && {
          column: "practiceName",
          value: this.practiceName
        },
        this.locationId && {
          column: "locationId",
          value: this.locationId
        },
        this.email && {
          column: "email",
          value: this.email
        }
      ].filter(item => item.hasOwnProperty("value"));

      if (fields.length) {
        const data = await searchAdminLogging(fields);
        if (data.length) {
          this.list = data;
          this.dialog = false;
          this.clearForm();
        } else {
          this.errorMessage =
            "Nothing was found for your request. Please try again";
          setTimeout(() => {
            this.errorMessage = "";
          }, 3000);
        }
      } else {
        this.errorMessage = "Please fill in one or more fields";
        setTimeout(() => {
          this.errorMessage = "";
        }, 2000);
      }
    },
    clearForm(): void {
      this.hygienistId = this.firstName = this.lastName = this.practiceName = this.locationId = this.email =
        "";
    },
    async refresh(): Promise<void> {
      this.loading = true;
      this.list = await getAdminLogging();
      this.loading = false;
    }
  }
});
